import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Axios from "middleware/axiosInstance";
import { Row, Col } from "antd";
import "antd/dist/antd.css";
import useAxios from "middleware/useAxios";
import { Button, Form, Input, Select, Space } from "antd";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import Icon from "react-multi-date-picker/components/icon";
import OpenNotificationWithIcon from "layouts/notificationWithIcon/OpenNotificationWithIcon ";
import { convertToMiladi } from "utils/dateCoverter";

const { Option } = Select;
const { TextArea } = Input;
const CreateWarehouseDocument = () => {
  // start react router url params
  const UrlParams = useParams();
  const docType = UrlParams.type;
  console.log(docType);
  // end react router url params
  const Naviate = useNavigate();
  const [form] = Form.useForm();
  const [dayOfDoc, setDayOfDoc] = useState(null);
  const [timeOfDoc, setTimeOfDoc] = useState(null);
  const [currentCountOfCommodities, setCurrentCountOfCommodities] = useState(
    []
  );
  const [selectedWarehouseId, setSelectedWarehouseId] = useState(null);
  const [
    allWarehouse,
  ] = useAxios({
    method: "get",
    url: "/anbar",
  });
  const [allPeople] =
    useAxios({
      method: "get",
      url: "/people",
    });

  const [
    allCommodity
  ] = useAxios({
    method: "GET",
    url: "/commodity",
  });

  const [newWarehouseEntryDocument, setNewWarehouseEntryDocument] = useState(
    {}
  );

  // const handleFormValuesChange = (changedValues) => {
  //   console.log(changedValues);
  //   setFormValues(changedValues);
  // };

  const handleFormValuesSubmit = (changedValues) => {
    const temp = changedValues;
    if (dayOfDoc?.miladi) {
      temp.date = dayOfDoc.miladi;
    } else {
      OpenNotificationWithIcon("خطا", "انتخاب تاریخ و ساعت الزامی است");
    }
    if (!temp.items[0]) {
      OpenNotificationWithIcon("خطا", "حداقل یک کالا اجباری است", "error");
    }

    temp.time = timeOfDoc;
    console.log(temp);
    // temp.items[2] ? null : alert("dsadda")
    // null : OpenNotificationWithIcon("خطا", "انتخاب ساعت الزامی است")
    // setNewWarehouseEntryDocument(temp);
    // CreateWarehouseEntryDocumentHandler();

    // const CreateWarehouseEntryDocumentHandler = async () => {

    Axios.post(docType === "entry" ? "/import" : "/export", temp)
      .then((res) => {
        console.log(res);
        OpenNotificationWithIcon("ثبت شد", "ثبت سند جدید انجام شد");
        Naviate(
          `/warehouse/warehouse-documents/${docType === "entry" ? "entry" : "exit"
          }`
        );
      })
      .catch((res) => {
        console.log(res);
        if (
          res.message ===
          "The output count cannot be greater than the input count"
        ) {
          OpenNotificationWithIcon(
            "کمبود موجودی",
            "موجودی کالای انتخاب شده کمتر از مقدار خروجی می باشد",
            "error"
          );
        } else if (res.message === "There are no products in this warehouse") {
          OpenNotificationWithIcon(
            "عدم موجودی",
            "کالای انتخابی در انبار انتخاب شده موجود نمی باشد",
            "error"
          );
        } else {
          OpenNotificationWithIcon(
            "ثبت نشد",
            "ثبت سند جدید انجام نشد",
            "error"
          );
        }
      });
    // };
  };
  const changeDateAndTimeOfDocHandler = (e) => {
    const time = `${e.hour}:${e.minute}:00`;
    // const time = `09:01:02`;
    setTimeOfDoc(time);
    const dateInShamsi = `${e.year}-${e.month.number}-${e.day}`;
    const dateInMiladi = convertToMiladi(dateInShamsi);
    setDayOfDoc({ shamsi: dateInShamsi, miladi: dateInMiladi });
    setNewWarehouseEntryDocument({
      ...newWarehouseEntryDocument,
      date: dateInMiladi,
      time: timeOfDoc,
    });
  };

  // useEffect to empty the
  useEffect(() => {
    setNewWarehouseEntryDocument({});
    console.log("component reseted");
    form.resetFields();
    setCurrentCountOfCommodities([]);
  }, [docType]);
  // useEffect to empty the

  // const commodityChangeHandler = (e) => {
  //   console.log("e")
  // }
  // const farzad = Form.useWatch("commodity_id", form);
  // useEffect(() => {
  //   console.log(farzad);
  //   console.log(getCommodityCurrentCount(8));
  // }, [farzad]);

  const getCommodityCurrentCount = (commodityId, rowIndex) => {
    Axios.post(`/count/${commodityId}`, {
      anbar_id: selectedWarehouseId,
    }).then((res) => {
      console.log(res.data.count);
      const temp = [...currentCountOfCommodities];
      temp[rowIndex] = { count: res.data.count };
      setCurrentCountOfCommodities(temp);
      console.log(temp);
      // const response = res.data.count
      // setCurrentCountOfCommodities({ ...currentCountOfCommodities, [rowIndex]: response })
    });
  };

  useEffect(() => {
    getCommodityCurrentCount();
  }, [selectedWarehouseId]);

  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <h5 className="title-session">
          سند
          <span>{docType === "entry" ? " ورود " : " خروج "}</span>
          انبار
        </h5>

        {/* <h1>
          {moment.from("1401/08/05", "fa", "YYYY/MM/DD").format("YYYY/MM/DD")}
        </h1>
        <h1>
          {moment("2022/10/27", "YYYY/MM/DD").locale("fa").format("YYYY/MM/DD")}
        </h1> */}
        <Form
          // layout="horizental"
          layout="vertical"
          // layout="inline"
          // {...formItemLayout}
          // layout={
          //     "span": 12,
          //     "offset": 12,
          //   },
          initialValues={{
            items: [{ name: "" }],
            // features: [{ feature: "", feature_value: "0" }]
          }}
          form={form}
          // onValuesChange={handleFormValuesChange}
          autoComplete="off"
          scrollToFirstError
          labelCol={{ xs: 24 }}
          onFinish={handleFormValuesSubmit}
        >

          <Row gutter={8}>
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item
                label={docType === "entry" ? "انبار ورود" : "انبار خروج"}
                name="anbar_id"
                rules={[
                  {
                    required: true,
                    message: "انتخاب انبار الزامی می باشد",
                  },
                ]}
              >
                <Select
                  onChange={(id) => setSelectedWarehouseId(id)}
                  // className={`${classNames.classes}`}
                  loading={!allWarehouse?.[0]}
                  showSearch
                  // style={{
                  //   width: 200,
                  // }}
                  // onChange={test}
                  fieldNames="anbar_id"
                  placeholder="انتخاب فرمایید"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                  id="anbar_id"
                >
                  {allWarehouse?.map((wareHouse) => {
                    return (
                      <Option key={wareHouse.id} value={wareHouse.id}>
                        {wareHouse.name}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item label="شماره سند" name="sh_sanad">
                <Input placeholder="12345" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item label="شماره عطف" name="sh_atf">
                <Input placeholder="12345" />
              </Form.Item>
            </Col>
            {/* <Col xs={12} sm={8} md={4}> */}
            <Col xs={24} sm={12} md={8} xl={6}>
              {/* <Form.Item label="تاریخ" name="date">
                < Calendar
                  value={selectedDay}
                  onChange={e => console.log(e)}
                  locale="fa" />
              </Form.Item> */}
              <Form.Item
                label="تاریخ"
                name="date"
                rules={[
                  {
                    required: !timeOfDoc,
                    message: "انتخاب ساعت و تاریخ الزامی می باشد",
                  },
                ]}
              >
                <Input
                  disabled
                  placeholder={
                    dayOfDoc
                      ? `${timeOfDoc} ${dayOfDoc.shamsi}`
                      : "انتخاب تاریخ"
                  }
                  addonBefore={
                    <DatePicker
                      // value={newWarehouseEntryDocument.date}
                      onChange={(e) => changeDateAndTimeOfDocHandler(e)}
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-left"
                      format="HH:MM"
                      plugins={[<TimePicker hideSeconds />]}
                      render={
                        <Icon
                          style={{
                            color: "gray",
                            width: "23px",
                          }}
                        />
                      }
                    />
                  }
                />
              </Form.Item>
            </Col>
            {/* <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item label="ساعت" name="time">
                <TimePicker
                 initialValues={moment("12:20", "HH:mm")}
                format={"HH:mm"}
                />
              </Form.Item>
            </Col> */}
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item
                label="شخص"
                name="people_id"
                rules={[
                  {
                    required: true,
                    message: "انتخاب شخص اجباری می باشد",
                  },
                ]}
              >
                <Select
                  // className={`${classNames.classes}`}
                  loading={!allPeople?.[0]}
                  showSearch
                  // style={{
                  //   width: 200,
                  // }}
                  // onChange={test}
                  fieldNames="people_id"
                  placeholder="انتخاب فرمایید"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                  id="people_id"
                >
                  {allPeople?.map((people) => {
                    return (
                      <Option key={people.id} value={people.id}>
                        {`${people.name} ${people.family}`}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item label="عنوان شخص" name="people_label">
                <Input placeholder="نماینده انبار" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item
                label="شخص دوم"
                name="people2_id"
              // rules={[
              //   {
              //     required: true,
              //     message: "انتخاب شخص اجباری است",
              //   },
              // ]}
              >
                <Select
                  // className={`${classNames.classes}`}
                  loading={!allPeople?.[0]}
                  showSearch
                  // style={{
                  //   width: 200,
                  // }}
                  // onChange={test}
                  fieldNames="people_id"
                  placeholder="انتخاب فرمایید"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                  id="people_id"
                >
                  {allPeople?.map((people) => {
                    return (
                      <Option key={people.id} value={people.id}>
                        {`${people.name} ${people.family}`}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item
                label="ارز"
                name="arz"
                rules={[
                  {
                    required: true,
                    message: "انتخاب ارز اجباری است",
                  },
                ]}
              >
                <Select
                  // className={`${classNames.classes}`}
                  showSearch
                  // style={{
                  //   width: 200,
                  // }}
                  // onChange={test}
                  fieldNames="arz"
                  placeholder="انتخاب فرمایید"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                  id="people_id"
                >
                  <Option value="rial">ریال</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item
                label="نوع سند"
                name="is_trust"
                rules={[
                  {
                    required: true,
                    message: "انتخاب نوع سند الزامی می باشد",
                  },
                ]}
              >
                <Select
                  // showSearch
                  // style={{
                  //   width: 200,
                  // }}
                  // onChange={test}
                  fieldNames="is_trust"
                  placeholder="انتخاب فرمایید"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                  id="is_trust"
                >

                  <Option value={true}>
                    امانی
                  </Option>
                  <Option value={false}>
                    قطعی
                  </Option>

                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item label="نرخ ارز" name="nerkh_arz">
                <Input placeholder="4200" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} xl={6}>
              <Form.Item label="شرح" name="description">
                <TextArea rows={4} placeholder="شرح" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={8}>
            <Col xs={24}>
              {/* start form list */}

              <Form.List
                name="items"
                onValuesChange={(e) => {
                  console.log(e);
                }}
              >
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <Space
                        key={key}
                        style={{ display: "flex", marginBottom: 8 }}
                        align="baseline"
                      >
                        <Form.Item
                          {...restField}
                          name={[name, "radif"]}
                          label="ردیف"
                        >
                          {/* row number */}
                          {name + 1}
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, "mojudi"]}
                          label="موجودی"
                        >
                          {currentCountOfCommodities[name]?.count}

                          {/* row number
                        {/* {formValues?.items[name].commodity_id &&
                            getCommodityCurrentCount(
                              formValues?.items[name].commodity_id
                            )} */}
                        </Form.Item>

                        <Form.Item
                          {...restField}
                          name={[name, docType === "entry" ? "commodity_id" : "commodity2_id"]}
                          label="شناسه/نام کالا"
                          // onValuesChange={commodityChangeHandler}
                          rules={[
                            {
                              required: true,
                              message: "انتخاب کالا اجباری است",
                            },
                          ]}
                        >
                          <Select
                            dropdownMatchSelectWidth={false}
                            onChange={(e) => {
                              getCommodityCurrentCount(e, name, restField);
                            }}
                            showSearch
                            loading={!allCommodity?.[0]}
                            placeholder="انتخاب فرمایید"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children.includes(input)
                            }
                            filterSort={(optionA, optionB) =>
                              optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                            }
                          >
                            {allCommodity?.map((kala) => {
                              return (
                                <Option key={kala.id} value={kala.id}>
                                  {`${kala.id} -${kala.name}`}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                        {/* <Form.Item label="نام کالا">
                          {newWarehouseEntryDocument.items[index]?.name ? newWarehouseEntryDocument.items[index].name : null}
                        </Form.Item> */}
                        <Form.Item
                          {...restField}
                          name={[name, docType === "entry" ? "count_im" : "count_ex"]}
                          label="تعداد"
                          rules={[
                            {
                              required: true,
                              message: "تعداد کالا اجباری است",
                            },
                            { min: 0 },
                            // { max: currentCountOfCommodities[name]?.count },
                            () => ({
                              validator(_, value) {
                                if (
                                  docType === "exit" &&
                                  value > currentCountOfCommodities[name]?.count
                                ) {
                                  return Promise.reject("بیشتر از موجودی");
                                } else return Promise.resolve();
                              },
                            }),
                          ]}
                        >
                          <Input type="number" placeholder="100" onWheel={(e) => e.target.blur()} />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, "fi"]}
                          label="فی"
                        >
                          <Input type="number" placeholder="4200" onWheel={(e) => e.target.blur()}/>
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, "price"]}
                          label="مبلغ"
                        >
                          <Input type="number" placeholder="8400" onWheel={(e) => e.target.blur()}/>
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          label={docType === "entry" ? "کد ورود" : "کد خروج"}
                          name={[name, "code_delivery"]}
                        >
                          <Input type="number" placeholder="8341" onWheel={(e) => e.target.blur()} />
                        </Form.Item>
                        {/* <Form.Item
                          {...restField}
                          label={
                            docType === "entry" ? "تاریخ ورود" : "تاریخ خروج"
                          }
                          name={[name, "date_delivery"]}
                        >
                          <Input placeholder="4200" />
                        </Form.Item> */}
                        <Form.Item
                          {...restField}
                          label="توضیحات"
                          name={[name, "description"]}
                        >
                          <Input type="text" placeholder="توضیحات" />
                        </Form.Item>
                        <MinusCircleOutlined
                          onClick={() => {
                            remove(name);
                            console.log(name);
                            currentCountOfCommodities.splice(name, 1);
                          }}
                        />
                      </Space>
                    ))}
                    <Form.Item>
                      <Button
                        type="dashed"
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined />}
                      >
                        ایجاد یک ردیف جدید
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
              {/* end form list */}
            </Col>
          </Row>
          <Form.Item
          // {...buttonItemLayout}
          >
            <Button
              htmlType="submit"
              type="primary"
            // onClick={CreateWarehouseEntryDocumentHandler}
            >
              ثبت
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default CreateWarehouseDocument;
